import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { BasketContext } from '../BasketProvider'
import { useK2Setup } from '@/eshop/hooks/useK2Setup'
import { useFormatPrice } from '@/eshop/utils/price'

export default function BasketTotal() {
    const { products } = useContext(BasketContext)
    const { t } = useTranslation()
    const k2 = useK2Setup()
    const formatPrice = useFormatPrice(k2.currencyCode, '---')

    return (
        <>
            <div className="mt-12 text-right">
                <div className="font-bold text-md">
                    {t('eshop.basket.table.totalPrice')}
                    <span className="ml-10">
                        {formatPrice(
                            products
                                .reduce(
                                    (acc, p) =>
                                        acc +
                                        parseFloat(p.price.toString()) *
                                            p.count,
                                    0
                                )
                                .toFixed(2)
                        )}
                    </span>
                </div>
                <div className="font-bold text-md">
                    {t('eshop.basket.table.totalPriceVAT')}
                    <span className="ml-10">
                        {formatPrice(
                            products
                                .reduce(
                                    (acc, p) =>
                                        acc +
                                        parseFloat(p.priceVAT.toString()) *
                                            p.count,
                                    0
                                )
                                .toFixed(2)
                        )}
                    </span>
                </div>
            </div>
            <hr className="mt-10" />
        </>
    )
}
